import Cookies from "js-cookie";
import React from "react";
import { useNavigate } from "react-router-dom";
import config from "../../config";
import { useTranslation } from "react-i18next";

const PathSelectionSection = () => {
  const navigate = useNavigate();
  const cookieValue = Cookies.get("token", { domain: config.cookieDomain });

  const { t } = useTranslation("home");

  const handleClick = (path) => {
    if (cookieValue) {
      navigate({
        pathname: "/rough",
        search: `?path=${path}`,
      });
    } else {
      navigate("/login");
    }
  };

  return (
    <div className="flex flex-col items-center gap-14">
      <div className="flex flex-col gap-5 items-center">
        <p className="font-semibold text-[46px] bg-clip-text bg-gradient-to-b from-black to-[#001354] text-center md-max:text-[32px]">
          {t("path.title")}
        </p>
        <p className="text-[#010D3E] text-[22px] text-center max-w-[600px] md-max:max-w-[90%] md-max:text-[18px]">
          {t("path.description")}
        </p>
      </div>
      <div className="flex gap-5 md-max:flex-col max-w-[990px] md-max:max-w-[90%]">
        {t("path.cards", { returnObjects: true }).map((card, index) => (
          <div
            key={index}
            className="flex flex-col items-center gap-3 py-10 px-12 md-max:px-6 bg-[#DFE8FE] rounded-[40px] w-max md-max:w-full"
          >
            <img
              src={card.img}
              alt=""
              className="object-cover h-[40vh] md-max:h-[300px]"
            />
            <p className="bg-clip-text bg-gradient-to-b from-black to-[#001354] font-semibold text-[26px]">
              {card.title}
            </p>
            <p className="text-[#010D3E] text-center">{card.description}</p>
            <button
              className="bg-white py-3 px-5 w-max rounded-full cursor-pointer hover:scale-105 duration-200"
              onClick={() => handleClick(card.key)}
            >
              {cookieValue ? card.button : card.buttonFallback}
            </button>
          </div>
        ))}
        {/* <div className='flex flex-col items-center gap-3 py-10 px-12 md-max:px-6 bg-[#DFE8FE] rounded-[40px] w-max md-max:w-full'>
              <img src="/path-char-2.png" alt="" className='object-cover h-[40vh] md-max:h-[300px]' />
              <p className='bg-clip-text bg-gradient-to-b from-black to-[#001354] font-semibold text-[26px]'>For Students</p>
              <p className='text-[#010D3E] text-center'>Unlock your potential with insights into study habits, adaptability, and self-development for academic success. </p>
              <button className='bg-white py-3 px-5 w-max rounded-full cursor-pointer hover:scale-105 duration-200' onClick={() => handleClick("student")}>{cookieValue ? "Start as Student" : "Start the Test"}</button>
            </div> */}
      </div>
    </div>
  );
};

export default PathSelectionSection;
